import { IReleaseNote } from "../types"

export const RELEASE_1_4_14: IReleaseNote = {
    status: "PAST",
    title: "v1.4.14",
    date: "24th March 2025",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content: "This patch includes an update to the Terms of Use page",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "The following change has been been added:",
            bullets: [
                "We have included a link to the 'Privacy Policy' page within the Terms of Use",
            ],
        },
        {
            heading: "For installers using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "The following change has been been added:",
            bullets: [
                "We have included a link to the 'Privacy Policy' page within the Terms of Use",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "The following change has been been added:",
            bullets: [
                "We have included a link to the 'Privacy Policy' page within the Terms of Use",
            ],
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "The following change has been been added:",
            bullets: [
                "We have included a link to the 'Privacy Policy' page within the Terms of Use",
            ],
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "The following change has been been added:",
            bullets: [
                "We have included a link to the 'Privacy Policy' page within the Terms of Use",
            ],
        },
    ],
}
